export default __webpack_public_path__ + "static/media/admin-done-resolved.d42f9ccc.gif";